import turfBbox from '@turf/bbox';
import turfPointOnFeature from '@turf/point-on-feature';
import { convertArea as turfConvertArea } from '@turf/helpers';

/**
 * Take geojson and shape (geojson is preferred) and return a point on the
 * polygon as a LatLng
 */
export const getInfoWindowPosition = ({ geojson, shape }) => {
  if (geojson) {
    return coordsToLatLng(turfPointOnFeature(geojson).geometry.coordinates);
  }

  const bounds = new window.google.maps.LatLngBounds();
  shape.forEach(latLng => {
    bounds.extend(new window.google.maps.LatLng(latLng));
  });
  return bounds.getCenter();
};

export const mergePaths = polygons =>
  polygons.reduce(
    (mergedPaths, polygon) => [...mergedPaths, ...polygon.paths],
    []
  );

export const formatGeo = point => {
  const lat = parseFloat(point.lat || point.latitude);
  const lng = parseFloat(point.lng || point.longitude);
  return { lat, lng };
};

export const sqMetersToAcres = sqMeters =>
  parseFloat(turfConvertArea(sqMeters, 'metres', 'acres').toFixed(2));

// Convert from turf-style bbox to Google-Maps-style LatLngBoundsLiteral
export const bboxToBounds = ([west, south, east, north]) => ({
  west,
  south,
  east,
  north,
});

// Convert from turf-style coords to Google-Maps-Style LatLngLiteral
export const coordsToLatLng = ([lng, lat]) => ({ lat, lng });

// Convert from Google-Maps-Style LatLngLiteral to turf-style coords
export const latLngToCoords = ({ lat, lng }) => [lng, lat];

// Get a shape suitable for "currently selected field" from a field object,
// which is just used for zooming the map to bounds
export const getShape = field => {
  if (field.shape && field.shape.length) {
    return field.shape;
  }

  // Approximate that from the geojson by using opposite corners of its bounding
  // box
  const [minX, minY, maxX, maxY] = turfBbox(
    typeof field.geojson === 'string'
      ? JSON.parse(field.geojson)
      : field.geojson
  );
  return [{ lat: minY, lng: minX }, { lat: maxY, lng: maxX }];
};



// WEBPACK FOOTER //
// ./src/common/components/MapComponent/util.js